import { MenuItem } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { ArrowRight } from '@mui/icons-material';
import toast from 'react-hot-toast';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { profitLoss } from "../../components/footer/AccountFooter";
import { closeOrderPosition, closeAllPrositionsByHedge, closePositionByHedge, OneClickTrading } from "../../api/request/dashboard/dashboard";
import { deletePositionsData } from "../../store/Slices/orderPositionSlice";
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import CloseByHedgeModal from '../../components/modal/CloseByHedge';
import EditPositionModal from '../../components/modal/EditSLTP/EditPositionModal';
import ClosePosition from '../../components/modal/trading/ClosePosition';
import { addJournalLog } from '../../components/tab/tabview/journal/addJournalLog';
import { getCookies } from '../../services/Cookies';

export default function TradeMenu({ isMobile = false, setSubmenuAnchor = () => { }, handleOpenModifyPositionModal, contextMenu, setContextMenu, style, showColumnsMenu }) {
    const dispatch = useDispatch();
    const { darkMode } = useContext(ThemeContext)
    const [t] = useTranslation()
    const [openEdit, setOpenEdit] = useState(false);
    const [editSLTP, setEditSLTP] = useState([]);
    // const [submenuAnchor, setSubmenuAnchor] = useState(null);
    const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
    const orderSLTP = useSelector((state) => state.orderPosition.orderSLTP, shallowEqual);
    const { symbols } = useSelector(state => state.watchlist)
    const { accountId } = useSelector(state => state.accountSummary)
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [hedgeModalOpen, setHedgeModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const selectedRowsRef = useRef(new Set());
    const [forceUpdate, setForceUpdate] = useState(false);
    const tradeDetail = contextMenu?.row || contextMenu
    const [closeModalOpen, setCloseModalOpen] = useState(false);
    const [selectedCloseTradeId, setSelectedCloseTradeId] = useState(null);
    const decimalPlaces = 2;
    const username = getCookies('username')

    const handleCloseContextMenu = () => {
        // setContextMenu(null);
        setSubmenuAnchor(null);
    };
    const handleEditClick = () => {
        if (!tradeDetail) return;
        const sltpData = orderSLTP.filter((sltp) => sltp.positionId === tradeDetail?.id);

        if (sltpData.length > 0) {
            setEditSLTP(sltpData);
            setOpenEdit(true);

            // handleCloseContextMenu();

        } else {
            toast.error("No S/L, T/P to edit");
        }
    };

    const handleModifyClick = () => {
        if (!tradeDetail) return;

        const positionId = tradeDetail.id;
        const sltpOrdersForPosition = orderSLTP.filter((item) => item.positionId === positionId);

        const positionAmount = tradeDetail.amount || 0;
        const totalManagedAmount = sltpOrdersForPosition.reduce((sum, item) => sum + (item.amount || 0), 0);
        const remainingAmount = Number((positionAmount - totalManagedAmount).toFixed(decimalPlaces));

        if (remainingAmount <= 0) {
            toast.error(`All ${positionAmount} lots are already managed.`);
        } else {
            const orderDetails = { row: tradeDetail };
            handleOpenModifyPositionModal(orderDetails);
        }

        handleCloseContextMenu();
    };


    const closeUnprofitablePositions = async () => {
        const unprofitableTrades = Array.from(profitLoss.entries())
            .filter(([_, value]) => parseFloat(value) < 0)
            .map(([key]) => {
                const [accountIdStr, positionIdStr] = key.split("-");
                const accountId = Number(accountIdStr);
                const positionId = Number(positionIdStr);

                const position = positions.find(
                    pos => pos.accountId === accountId && pos.id === positionId
                );

                if (!position) return null;

                return {
                    accountId,
                    amount: position.amount,
                    positionId,
                };
            })
            .filter(Boolean);


        if (unprofitableTrades.length === 0) {
            toast.error("No unprofitable positions found!");
            return;
        }
        try {
            const results = await Promise.allSettled(
                unprofitableTrades.map(trade => closeOrderPosition(trade))
            );

            // Extract successfully closed positions
            const successfulTrades = unprofitableTrades.filter((_, index) => results[index].status === "fulfilled");
            if (successfulTrades.length > 0) {
                successfulTrades.forEach(trade => {
                    const position = positions.find(pos => pos.id === trade.positionId);
                    if (position) {
                        // toast.success(`Closed Trade #${trade.positionId}`);
                        addJournalLog('tradeClosed', `Trade closed: ID #${position.id}, ${position.symbolName}, at ${position.openPrice}, ${position.side == 1 ? "Buy" : "Sell"}, Amount: ${position.amount}, P/L: ${position.profitLoss}, Account ${username}: ${accountId}.`);

                    }
                });
            }
            else {
                const failedResults = results.filter(r => r.status === "rejected");
                const messages = failedResults.map(r => r.reason?.response?.data?.message || r.reason?.message || "Unknown error");
                addJournalLog('closePositionError', `Close position: #${tradeDetail.id} failure: ${messages}, Account ${username}: ${accountId}.`);

                toast.error(messages.join("\n") || "Failed to close positions.");

            }
            // Dispatch delete only for successful closures
            successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


        } catch (error) {
            console.error("Error closing unprofitable positions:", error);
            toast.error("An error occurred while closing positions.", error);
        }
        finally {
            handleCloseContextMenu();
        }

    };
    const closeAllByHedge = async (symbolId) => {
        if (!symbolId) {
            toast.error("Invalid symbol ID.");
            return;
        }

        const symbolPositions = positions.filter(pos => pos.symbolId === symbolId);
        const buys = symbolPositions.filter(p => p.side === 1).map(p => ({ ...p }));
        const sells = symbolPositions.filter(p => p.side === -1).map(p => ({ ...p }));


        const hedgedPairs = [];

        while (buys.length > 0 && sells.length > 0) {
            const buy = buys[0];
            const sell = sells[0];

            const hedgeAmount = Math.min(buy.amount, sell.amount);

            hedgedPairs.push({
                accountId: buy.accountId,
                amount: hedgeAmount,
                firstPositionId: buy.id,
                secondPositionId: sell.id
            });

            if (buy.amount > hedgeAmount) {
                buy.amount -= hedgeAmount;
            } else {
                buys.shift();
            }

            if (sell.amount > hedgeAmount) {
                sell.amount -= hedgeAmount;
            } else {
                sells.shift();
            }
        }

        if (hedgedPairs.length === 0) {
            toast.error("No hedge trades found to close for selected symbol.");
            return;
        }

        const payload = { orders: hedgedPairs };

        try {
            const response = await closeAllPrositionsByHedge(payload);
            const responses = response?.data?.responses;

            if (!Array.isArray(responses)) {
                toast.error("Unexpected response format.");
                return;
            }

            responses.forEach((res, index) => {
                const order = payload.orders[index];
                const pos1 = positions.find(p => p.id === order.firstPositionId);
                const pos2 = positions.find(p => p.id === order.secondPositionId);
                const symbolData = symbols[pos1?.symbolId];
                const price = pos1?.side == 1 ? symbolData?.bid : symbolData?.ask;
                const side = pos1?.side == 1 ? "Buy" : "Sell";

                if (res?.statusCode === 400) {
                    const errorMsg = res?.body?.message || "Failed to close position.";
                    toast.error(`Error: ${errorMsg} (Symbol: ${pos1?.symbolName}, amount: ${order.amount})`);
                }
                else if (res?.statusCode === 200) {
                    dispatch(deletePositionsData({ id: order.firstPositionId, amount: order.amount }));
                    dispatch(deletePositionsData({ id: order.secondPositionId, amount: order.amount }));
                    // toast.success(`Closed Hedge Trades #${order.firstPositionId} & #${order.secondPositionId} (${pos1?.symbolName}) at ${price}, ${side}, amount ${order.amount}`);
                }
            });

        } catch (error) {
            console.error("Error closing trades:", error);
            toast.error("Failed to close trades.");
        }

        handleCloseContextMenu();
    };

    const closePositionBy_Hedge = async (firstPositionId, secondPositionId, amount) => {
        if (!firstPositionId || !secondPositionId) {
            toast.error("Invalid position IDs.");
            return;
        }

        const payload = {
            accountId: accountId,
            amount: amount,
            firstPositionId,
            secondPositionId
        };

        try {
            const response = await closePositionByHedge(payload);

            const firstPos = positions.find(pos => pos.id === firstPositionId);
            const secondPos = positions.find(pos => pos.id === secondPositionId);

            if (firstPos && symbols[firstPos.symbolId]) {
                toast.success(`Closed Trade #${firstPositionId} (${firstPos.symbolName}) at ${firstPos.side == 1 ? symbols[firstPos.symbolId].bid : symbols[firstPos.symbolId].ask} , ${firstPos.side == 1 ? "Buy" : "Sell"} amount ${amount} P/L ${firstPos.profitLoss}`);
            }

            if (secondPos && symbols[secondPos.symbolId]) {
                toast.success(`Closed Trade #${secondPositionId} (${secondPos.symbolName}) at ${secondPos.side == 1 ? symbols[secondPos.symbolId].bid : symbols[secondPos.symbolId].ask} , ${secondPos.side == 1 ? "Buy" : "Sell"} amount ${amount} P/L ${secondPos.profitLoss}`);
            }

            return response.data;
        } catch (error) {
            console.error("Error closing position by hedge:", error);
            toast.error(error);
        }
    };

    const doublePosition = async () => {
        console.log(`double ${JSON.stringify(tradeDetail)}`);

        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const { accountId, symbolId, amount, side } = tradeDetail;

        const payload = {
            accountId: accountId,
            side: side,
            amount: amount,
            symbolId: symbolId,
            comment: "Opened by Double Position",
        };

        try {
            const response = await OneClickTrading(payload);
            const newTradeId = response?.id || response?.data?.id;

            if (newTradeId) {
                toast.success(`Opened Trade #${newTradeId} (${tradeDetail.symbolName}) at ${side == 1 ? symbols[symbolId].bid : symbols[symbolId].ask}, ${side == 1 ? "Buy" : "Sell"} amount ${amount}`);
            } else {
                toast.success(`Opened Trade (${tradeDetail.symbolName}) - ID not available`);
            }
        } catch (error) {
            console.error("Failed to double the position:", error);
            toast.error(error);
        }
        finally {
            handleCloseContextMenu();
        }
    };

    const inversePosition = async () => {
        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const { accountId, symbolId, amount, side, id } = tradeDetail;

        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const inversePayload = {
            accountId: accountId,
            side: side == 1 ? -1 : 1,
            amount: amount,
            symbolId: symbolId,
            comment: `Inverse of trade #${id}`,
        };

        const originalSymbol = symbols[symbolId];
        const price = side == 1 ? originalSymbol?.ask : originalSymbol?.bid;

        try {
            //  Open the inverse position
            await OneClickTrading(inversePayload);
            // toast.success(`Trade Opened #${tradeDetail?.id} (${symbols[tradeDetail?.symbolId]?.name}) at ${tradeDetail?.side == 1 ? symbols[tradeDetail?.symbolId]?.bid : symbols[tradeDetail?.symbolId]?.ask} ${tradeDetail?.side == 1 ? "Buy" : "Sell"} , amount ${tradeDetail.amount}`);
        } catch (error) {
            console.error("Failed to open inverse position:", error);
            toast.error("Failed to open inverse position.");
            handleCloseContextMenu();
            return;
        }

        // Close the original position
        try {
            const closePayload = {
                accountId: Number(accountId),
                positionId: id,
                amount: amount,
            };

            const closeResponse = await closeOrderPosition(closePayload);

            if (closeResponse.status === 200) {
                addJournalLog('tradeClosed', `Trade closed: ID #${id}, ${originalSymbol?.name}, at ${price}, ${side == 1 ? "Buy" : "Sell"}, Amount: ${amount}, Account ${username}: ${accountId}.`);
                // toast.success(`Closed Trade #${id} (${originalSymbol?.name}) at ${price}, ${side == 1 ? "Buy" : "Sell"}, amount ${amount}`);
            } else {
                addJournalLog('inversePositionError', `Inverse position: #${selectedPosition.id} failure: ${closeResponse?.data?.message}, Account ${username}: ${accountId}.`);
                toast.error(`Failed to close original trade #${id}`);
            }
        } catch (error) {
            const apiMessage = error?.response?.data?.message || error?.message || "Unknown error";
            addJournalLog('closePositionError', `Close position: #${selectedPosition.id} failure: ${apiMessage}, Account ${username}: ${accountId}.`);
            console.error("Failed to close original position:", error);
            toast.error("Error closing the original position.");
        } finally {
            handleCloseContextMenu();
        }
    };

    const closeProfitablePositions = async () => {
        const profitableTrades = Array.from(profitLoss.entries())
            .filter(([_, value]) => parseFloat(value) > 0)
            .map(([key]) => {
                const [accountIdStr, positionIdStr] = key.split("-");
                const accountId = Number(accountIdStr);
                const positionId = Number(positionIdStr);

                const position = positions.find(
                    pos => pos.accountId === accountId && pos.id === positionId
                );

                if (!position) return null;

                return {
                    accountId,
                    amount: position.amount,
                    positionId,
                };
            })
            .filter(Boolean);

        if (profitableTrades.length === 0) {
            toast.error("No profitable positions found!");
            return;
        }

        try {
            const results = await Promise.allSettled(
                profitableTrades.map(trade => closeOrderPosition(trade))
            );

            // Extract successfully closed positions
            const successfulTrades = profitableTrades.filter((_, index) => results[index].status === "fulfilled");
            if (successfulTrades.length > 0) {
                successfulTrades.forEach(trade => {
                    const position = positions.find(pos => pos.id === trade.positionId);
                    if (position) {

                        addJournalLog('tradeClosed', `Trade closed: ID #${position.id}, ${position.symbolName}, at ${position.openPrice}, ${position.side == 1 ? "Buy" : "Sell"}, Amount: ${position.amount}, P/L: ${position.profitLoss}, Account ${username}: ${accountId}.`);
                        // toast.success(`Closed Trade #${trade.positionId} (${position.symbolName}) at ${position.side == 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side == 1 ? "Buy" : 'Sell'} amount ${position.amount} `);
                    }
                });

            } else {
                const failedResults = results.filter(r => r.status === "rejected");
                const messages = failedResults.map(r => r.reason?.response?.data?.message || r.reason?.message || "Unknown error");
                addJournalLog('closePositionError', `Close position: #${tradeDetail.id} failure: ${messages}, Account ${username}: ${accountId}.`);

                toast.error(messages.join("\n") || "Failed to close positions.");
            }
            // Dispatch delete only for successful closures
            successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


        } catch (error) {
            const apiMessage = error?.response?.data?.message || error?.message || "Unknown error";
            addJournalLog('closePositionError', `Close position: #${selectedPosition?.id} failure: ${apiMessage}, Account ${username}: ${accountId}.`);
            console.error("Error closing profitable positions:", error);
            toast.error(error);
        } finally {
            handleCloseContextMenu();
        }
    };

    const handleCloseByHedgeClick = () => {

        if (!tradeDetail?.id) {
            toast.error("Invalid position.");
            return;
        }

        const oppositePosition = positions.find((pos) => pos.symbolId === tradeDetail?.symbolId && pos.side !== tradeDetail?.side);

        if (oppositePosition) {
            const { bid, ask, bidColor, askColor, digits } = symbols[tradeDetail?.symbolId] || {};

            if (bid !== undefined && ask !== undefined) {
                setSelectedPosition({ ...tradeDetail, bid, ask, bidColor, askColor, digits });
                setHedgeModalOpen(true);
                handleCloseContextMenu();
            } else {
                toast.error("Bid and ask prices not available.");
            }
        } else {
            toast.error("No opposite positions available for hedge.");
        }
    };
    const handleCloseClick = async (rowIndex = null, orderId = null, customAmount = null) => {
        const ordersToClose = orderId ? [orderId] : rowIndex !== null ? [positions[rowIndex]?.id] : selectedRows;

        if (ordersToClose.length === 0) {
            toast.error("No trades selected");
            return;
        }

        const closeRequests = ordersToClose.map(async (orderId) => {
            const selectedRow = positions.find(row => row.id === orderId);
            if (!selectedRow) return { success: false, positionId: orderId };

            const closeOrderPayload = {
                accountId: Number(accountId),
                positionId: selectedRow.id,
                amount: customAmount ?? selectedRow.amount,
            };

            try {
                const response = await closeOrderPosition(closeOrderPayload);
                if (response.status === 200) {
                    // dispatch(deletePositionsData(orderId));
                    // addJournalLog('tradeClosed', `Position closed #${selectedPosition.id}`);
                    return { success: true, positionId: orderId, position: selectedRow, message: response?.data?.message || "Unexpected error" };
                }
            } catch (error) {
                const apiMessage = error?.response?.data?.message || error?.message || "Unknown error";
                console.error("Error closing order:", error);
                addJournalLog('closePositionError', `Close position: #${selectedRow.id} failure: ${error}, Account ${username}: ${accountId}.`);
                return { success: false, positionId: orderId, position: selectedRow, message: apiMessage, };
            }
            return { success: false, positionId: orderId, position: selectedRow };
        });

        const results = await Promise.allSettled(closeRequests);

        results.forEach(({ status, value }) => {
            if (status === "fulfilled" && value?.success) {
                const { positionId, position } = value;
                if (position) {
                    const { symbolId, symbolName, side, profitLoss } = position;
                    const price = side == 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
                    const tradeSide = side == 1 ? "Buy" : "Sell";

                    // toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide} , amount ${customAmount || position.amount}, P/L ${profitLoss}`);
                }
            } else {
                const { positionId, position, message } = value;
                if (position) {
                    const { symbolId, symbolName, side } = position;
                    const price = side == 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

                    toast.error(` Failed to close Trade #${positionId} (${symbolName}) at ${price} due to: ${message || "unknown error"}`);
                }
            }
        });

        setSelectedRows([]);
        selectedRowsRef.current = [];
        setForceUpdate(prev => !prev);
        handleCloseContextMenu();
    };
    const handleConfirmClose = async (amount) => {
        await handleCloseClick(null, selectedCloseTradeId, amount);
        setCloseModalOpen(false);
        setContextMenu(null)

    };

    const handleClosePositionMenuClick = () => {
        if (tradeDetail) {
            setSelectedPosition(tradeDetail);
            setSelectedCloseTradeId(tradeDetail?.id);
            setCloseModalOpen(true);
        } else {
            toast.error("No trade selected to close.");
        }
    };


    const closeModal_CloseByHedgeModal = () => {
        setHedgeModalOpen(false);
        setContextMenu(null);
    }
    const closeModal_ClosePosition = () => {
        setCloseModalOpen(false);
        setContextMenu(null);
    }
    const closeModal_EditPosition = () => {
        setOpenEdit(false);
        setContextMenu(null);
    }
    return (
        <>
            <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                {isMobile ? (
                    <>
                        <MenuItem sx={style} onClick={handleClosePositionMenuClick}> {t("ClosePosition")} ({tradeDetail?.symbolName}) </MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); handleModifyClick(); }}>{t('modifyPosition')}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); closeProfitablePositions(); }}> {t('closeProfitablePosition')} </MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); closeUnprofitablePositions(); }}> {t('closeUnrofitablePosition')} </MenuItem>
                    </>
                ) : (
                    <>
                        {/* <MenuItem sx={style} onClick={() => { setContextMenu(null); handleChartFromTradeTabClick(symbols[tradeDetail.symbolId]) }}>{t('chart')}</MenuItem> */}
                        <MenuItem MenuItem sx={style} onClick={handleEditClick}>{t('editposition')}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); handleModifyClick(); }}>{t('modifyPosition')}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); inversePosition(); }}>{t('inversePosition')}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); doublePosition(); }}>{t('doublePosition')}</MenuItem>
                        <MenuItem sx={style} onClick={handleClosePositionMenuClick}>{t("ClosePosition")} ({tradeDetail?.symbolName})</MenuItem>
                        <MenuItem sx={style} onClick={() => { handleCloseByHedgeClick(); }}>{t("closeByHedge")}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); closeAllByHedge(tradeDetail?.symbolId, tradeDetail?.amount) }}>{t('closeAllByHedge')} ({tradeDetail?.symbolName})</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); closeProfitablePositions(); }}>{t('closeProfitablePosition')}</MenuItem>
                        <MenuItem sx={style} onClick={() => { setContextMenu(null); closeUnprofitablePositions(); }}>{t('closeUnrofitablePosition')}</MenuItem>
                        {showColumnsMenu && <MenuItem onClick={(e) => setSubmenuAnchor?.(e.currentTarget)} sx={style}>{t('columns')} <ArrowRight /></MenuItem>}
                    </>
                )}
            </div >

            {hedgeModalOpen && (<CloseByHedgeModal open={hedgeModalOpen} onClose={closeModal_CloseByHedgeModal} selectedPosition={selectedPosition} closePositionBy_Hedge={closePositionBy_Hedge} />)
            }
            {openEdit && (<EditPositionModal open={openEdit} handleClose={closeModal_EditPosition} editSLTP={editSLTP} />)}
            {closeModalOpen && (<ClosePosition open={closeModalOpen} onClose={closeModal_ClosePosition} selectedPosition={selectedPosition} onConfirm={handleConfirmClose} />)}
        </>
    )
}
